import {useEffect, useState} from "react";
import {MapContainer, TileLayer, Polyline, Marker, Popup, useMap} from 'react-leaflet';
import L from 'leaflet';
import {calculateDistance} from "../../utils/utils";

import 'leaflet/dist/leaflet.css';

// Fix for default marker icons in Leaflet (required for React)
delete L.Icon.Default.prototype._getIconUrl;L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

// @ts-ignore
export const RouteMap = ({ points, onDistanceCalculated }) => {
  const [distance, setDistance] = useState(0);

  useEffect(() => {
    if (points.length > 1) {
      let totalDistance = 0;
      for (let i = 0; i < points.length - 1; i++) {
        const lat1 = points[i].lat;
        const lon1 = points[i].lon;
        const lat2 = points[i + 1].lat;
        const lon2 = points[i + 1].lon;
        totalDistance += calculateDistance(lat1, lon1, lat2, lon2);
      }
      setDistance(totalDistance);
      if (onDistanceCalculated) {
        onDistanceCalculated(totalDistance);
      }
    }
  }, [points, onDistanceCalculated]);

  if (points.length === 0) {
    return <div>No points provided</div>;
  }

  const center = points[0];

  const FitBounds = ({ points }: { points: { lat: number; lon: number }[] }) => {
    const map = useMap();

    useEffect(() => {
      if (points.length > 0) {
        const bounds = L.latLngBounds(points.map(p => [p.lat, p.lon]));
        map.fitBounds(bounds.pad(0));
      }
    }, [points, map]);

    return null;
  };

  return (
    <div className="map-container" style={{ height: '30rem', width: '100%' }}>
      <MapContainer
        zoom={18}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Polyline
          positions={points.map((p: any) => [p.lat, p.lon])}
          color="blue"
          weight={3}
        />
        <FitBounds points={points} />
        <Marker position={[points[0].lat, points[0].lon]}>
          <Popup>Point start</Popup>
        </Marker>
        <Marker position={[points[points.length-1].lat, points[points.length-1].lon]}>
          <Popup>Point end</Popup>
        </Marker>
      </MapContainer>
      {distance > 0 && (
        <div className="distance-info">
          Total Distance: {(distance / 1000).toFixed(2)} km
        </div>
      )}
    </div>
  );
};